import IMG_LOGO from "./images/logo-full-vneid.svg";
import IMG_PIC_APP from "./images/pic-app.svg";
import IMG_APP_STORE from "./images/app-store-badge.svg";
import IMG_GG_PLAY from "./images/google-play-badge.svg";

import "./App.css";

function App() {
  return (
    <div className="w-full antialiased">
      <section className="w-full bg-[#5F0004]"></section>
      <section className="flex flex-col items-center bg-image-login bg-contain bg-top bg-no-repeat pt-[8px] md:bg-cover md:bg-center w-full">
        <span className="mb-[8px]">
          <img src={IMG_LOGO} width={236} height={176} alt="logo vneid" />
        </span>
        <div className="mt-3 w-full bg-white md:mt-0">
          <div className="my-10 flex flex-col-reverse items-center justify-center text-start md:my-0 md:flex-row md:space-x-4 md:px-4">
            <img src={IMG_PIC_APP} alt="" width={558} height={374} />
            <div className="mb-6 md:mt-0 md:px-0">
              <div className="mx-8 md:mx-0">
                <p className="m-0 font-Inter-Bold text-[22px] leading-8 text-[#3E3333] md:pt-4 md:text-[28px]">
                  Tải ngay ứng dụng VNeID
                </p>
                <p className="m-0 my-5 w-full font-Inter-Regular text-[16px] leading-5 text-[#3E3333] md:max-w-[558px]">
                  Để tiếp tục sử dụng dịch vụ liên quan xác thực và định danh
                  điện tử, vui lòng tải ứng dụng VNeID bằng cách nhấn vào biểu
                  tượng của App Store hoặc Google Play bên dưới.{" "}
                </p>
              </div>
              <div className="mx-4 mt-6 flex items-center justify-center sm:mx-0 md:justify-start">
                {/* <Image src={IMG_QR} alt="image qr" width={120} height={120} /> */}
                <div className="flex gap-3 lg:gap-6">
                  <a
                    href="https://apps.apple.com/vn/app/vneid/id1582750372?l=vi"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={IMG_APP_STORE}
                      alt="logo app store"
                      width={162}
                      height={48}
                    />
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.vnid"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={IMG_GG_PLAY}
                      alt="logo google play"
                      width={162}
                      height={48}
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <section className="w-full border-t-4 border-[#D71920] bg-[#F5F4F4]">
            <div className="mx-auto p-6 text-left sm:px-10 md:py-3 lg:container lg:max-w-[1280px] lg:px-4">
              <div className="items-center justify-between lg:flex">
                <div className="flex flex-col space-y-3 font-Inter-Bold text-[14px] text-[#3E3333] lg:flex-row lg:space-y-0 lg:space-x-3">
                  <a href="https://vneid.gov.vn/faq">
                    <div className="cursor-pointer text-[#3e3333]">
                      Câu hỏi thường gặp
                    </div>
                  </a>
                  <a href="https://vneid.gov.vn/dieu-khoan">
                    <div className="cursor-pointer text-[#3e3333]">
                      Điều khoản sử dụng dịch vụ
                    </div>
                  </a>
                  <a href="https://vneid.gov.vn/chinh-sach">
                    <div className="cursor-pointer text-[#3e3333]">
                      Chính sách quyền riêng tư
                    </div>
                  </a>
                </div>
                <div className="mt-6  text-[14px] text-[#3E3333] lg:mt-0">
                  <span>
                    © Bản quyền thuộc về Trung tâm dữ liệu Quốc gia về dân cư
                  </span>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>
    </div>
  );
}

export default App;
